<div class="container mt-4">
    <h2>{{ editingRoom ? 'Editar Habitación' : 'Crear Nueva Habitación' }}</h2>
    <form [formGroup]="roomForm" (ngSubmit)="saveRoom()">
      <div class="row">
        <div class="col-md-6">
          <label>Nombre:</label>
          <input class="form-control" formControlName="name" />
        </div>
        <div class="col-md-6">
          <label>Descripción:</label>
          <input class="form-control" formControlName="description" />
        </div>
        <div class="col-md-3 mt-3">
          <label>Número de habitación:</label>
          <input type="number" class="form-control" formControlName="number" />
        </div>
        <div class="col-md-3 mt-3">
          <label>Capacidad:</label>
          <input type="number" class="form-control" formControlName="capacity" />
        </div>
        <div class="col-md-3 mt-3">
          <label>Camas Individuales:</label>
          <input type="number" class="form-control" formControlName="bedsSingle" />
        </div>
        <div class="col-md-3 mt-3">
          <label>Camas Dobles:</label>
          <input type="number" class="form-control" formControlName="bedsDouble" />
        </div>
        <div class="col-md-4 mt-3">
          <label>Precio por Noche:</label>
          <input type="number" class="form-control" formControlName="nightPrice" />
        </div>
      </div>
  
      <div class="mt-3">
        <button class="btn btn-primary" type="submit" [disabled]="roomForm.invalid">
          {{ editingRoom ? 'Actualizar' : 'Crear' }}
        </button>
        <button class="btn btn-secondary" type="button" (click)="cancelEdit()" *ngIf="editingRoom">Cancelar</button>
      </div>
    </form>
  
    <hr class="my-4" />
  
    <h3>Listado de Habitaciones</h3>
    <table class="table table-striped mt-3" *ngIf="rooms.length > 0">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Descripción</th>
          <th>Capacidad</th>
          <th>Número</th>
          <th>Camas 1P</th>
          <th>Camas 2P</th>
          <th>Precio</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let room of rooms">
          <td>{{ room.name }}</td>
          <td>{{ room.description }}</td>
          <td>{{ room.capacity }}</td>
          <td>{{ room.number }}</td>
          <td>{{ room.bedsSingle }}</td>
          <td>{{ room.bedsDouble }}</td>
          <td>${{ room.nightPrice }}</td>
          <td class="text-nowrap">
            <button mat-icon-button color="accent" title="Editar habitacion" aria-label="Editar habitacion" (click)="editRoom(room)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" title="Eliminar habitacion" aria-label="Eliminar habitacion" (click)="deleteRoom(room.id)">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="rooms.length === 0" class="text-muted">No hay habitaciones registradas.</p>
  </div>
  
